import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

import AbEnvironment from "../auth/AbEnvironment";


const abEnvironment = new AbEnvironment();
const mutation = graphql`
mutation FormUpdateMutation($input: UpdateFormTByFormIdInput!) {
  updateFormTByFormId (input: $input) {
    formT {
      formId
    }
  }
}
`;

/**
 * Commit for the "form update" save, which involves the top level form and any form_detail_t entries to create.
 * TODO: determine how to update existing detail fields, how to delete detail and detail values, etc...
 * @param {UUID} formId formId for the current edit..
 * @param {String} formName Name of the form (displayable to vendor)
 * @param {String} formTitle Title of the form (displayed to partners who fill out the form)
 * @param {String} formSubtitle Form Subtitle (additional info displayed to partners filling form)
 * @param {String} description Description of form for the vendor
 * @param {JSONArray} formDetails Object containing arrays of fields within the form
 * @returns {Promise} of the executed graphql mutation; response if succcess, error if not.
 */
function commit(formId, formName, description, formTitle, formSubtitle) {
  var variables = {
    input: {
      formId: formId,
      formTPatch: {}
    }
  };

  //only add the field for update if they were actually modified in any way.
  //name, description and title should be validated before calling commit; if not, ensure defined.
  if (formName)
    variables.input.formTPatch.formName = formName;
  if (description)
    variables.input.formTPatch.description = description;
  if (formTitle)
    variables.input.formTPatch.formTitle = formTitle;
  if (formSubtitle && formSubtitle.length > 0) {
    variables.input.formTPatch.formSubtitle = formSubtitle;
  } else if (formSubtitle && formSubtitle.length === 0) {
    //defined and length == 0
    variables.input.formTPatch.formSubtitle = null;
  }

  //the function to run on promise
  return new Promise((resolve, reject) => {
    commitMutation(abEnvironment.getEnvironment(), {
        mutation,
        variables,
        onCompleted: response => {
          resolve(response);
        },
        onError: error => {
          reject(error);
        }
      });
  });
}

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { commit };